
import React, { useState, useEffect } from 'react';

import { cx } from '@emotion/css';
import * as styles from './batches.style.js';
// import "./batches.css";
import Amplify, { Auth } from 'aws-amplify';
import EditBatchIcon from '../../assets/images/edit-batch.png';
import { Hint } from 'react-autocomplete-hint';
import Select from 'react-select';
import { selectMedium } from '../../styles/components/forms.style';

function CreateBatchPopUp(props) {
  const [batchname, setBatchname] = React.useState('');
  const [category, setCategory] = React.useState('');
  const [status, setStatus] = React.useState('Create Batch');
  const categorytypes = [
    'Mathematics',
    'General Knowledge',
    'Chess',
    'SpellBowl',
  ];
  const [checks, setChecks] = React.useState('');


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        let useremail = Auth.user.attributes.email;
        ////console.log(useremail)

        // console.log("Chala");
        if (user.username.includes("Google_")) {


          createBatch(batchname, user.attributes['email'], useremail, jwt);

        }
        else {

          createBatch(batchname, user.username, useremail, jwt);


        }





      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }
  };


  // const getToken = async () => {

  //   let user = null;
  //   try {
  //     user = await Auth.currentAuthenticatedUser();

  //     Auth.currentSession().then((res) => {
  //       let accessToken = res.getAccessToken();
  //       let jwt = accessToken.getJwtToken();
  //       getEventsfromDB(user.username, jwt);

  //     });




  //   } catch (error) {
  //     console.log(error)
  //     Auth.signOut();
  //   }
  // };

  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken();
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken();
  //     ////console.log("Got jwt ")
  //     let useremail = Auth.user.attributes.email;
  //     ////console.log(useremail)
  //     createBatch(batchname, Auth.user.username, useremail, jwt);
  //   });
  // };

  const createBatch = async (batchname, username, useremail, jwt) => {
    const id = Date.now();

    if (batchname == '' || batchname == 'Batch Name') {
      setChecks('Invalid Batch Name');
    } else if (category == '' || category == 'Category') {
      setChecks('Invalid Category');
    } else {
      setStatus('Creating Batch...');
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },

        body: JSON.stringify({
          category: category,
          classowner: username,
          id: id,
          name: batchname,
          email: useremail,
          sendEmail: true,
          members: [],
        }),
      };
      ////console.log(requestOptions)
      const response = await fetch(
        `https://api.dev.quizwizard.net/quiz/createbatch`,
        requestOptions
      );
      const data = await response.json();
      ////console.log(data)
      props.selected();
    }
  };

  function createbatch() {
    getToken();
  }

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")

    document.title = 'Create Batch';

  }, []);

  return (
    <div className="mypopup-box">
      <div className="mybox createBatchesMain">
        {checks}
        <span className="close-icon" onClick={props.handleClose}>
          &#10005;
        </span>
        <div className={cx(styles.editBatchesMain)}>
          <div className={cx(styles.editBatchIcon)}>
            <img src={EditBatchIcon} alt="" />
          </div>
          <h3>Create New Batch</h3>
          <div className="add-item-box">
            <input
              name="batchname"
              type="text"
              spellCheck="false"
              autoComplete="off"
              value={batchname}
              onChange={(e) => setBatchname(e.target.value)}
              placeholder="Batch Name"
              required
            />
          </div>
          {/* <Hint options={["Chess", "Spell Bowl 0", "Spell Bowl 50","Spell Bowl 100","Spell Bowl 150","Spell Bowl 200",
          "Spell Bowl 250", "Spell Bowl 300","Spell Bowl 350","Spell Bowl 400","Spell Bowl 450",
          "Spell Bowl 500", "Spell Bowl 550","Spell Bowl 600","Spell Bowl 650","Spell Bowl 700",
          

          "Sports","General Knowledge","Mathematics"]}>
          
          
          </Hint> */}

          <div className="add-item-box">
            <span class="custom-dropdown">
              <Select
                name="category"
                className={selectMedium}
                classNamePrefix="select"
                value={category.length && { label: category, value: category }}
                placeholder="Category"
                onChange={(e) => setCategory(e.value)}
                options={categorytypes.map((questiontype) => ({
                  label: questiontype,
                  value: questiontype,
                }))}
              />
            </span>
          </div>
          <button class="createeventbutton" onClick={createbatch}>
            {status}
          </button>
        </div>
      </div>
    </div >
  );
}

export default CreateBatchPopUp;
